module.exports = __webpack_public_path__ + "static/img/glove_brique.a8bb4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_brique.png
// module id = X7Vo
// module chunks = 0